export const environment = {
   production: true,

   apiUrl: 'https://nm58vmtm0b.execute-api.eu-central-1.amazonaws.com/dev',
    //  currentUrl: 'http://localhost:4200/',
     currentUrl: 'https://originality.inspera.com/',
   linkedInKey: '8680zqbivxc0lo',
   externalReport: 'https://d20y34nzxtn3fz.cloudfront.net/',
  //  externalReport: 'http://localhost:4200/',
   externalCodeReport: 'https://d1pos327mdwffy.cloudfront.net/',
   pilotApp: true
  //  externalCodeReport: 'http://localhost:8080/'
};